import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DocumentViewerComponent } from 'src/app/modules/dashboard/modules/my-directory/pages/document-viewer/document-viewer.component';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/core/toast.service';

@Component({
  selector: 'app-share-popup',
  templateUrl: './share-popup.component.html',
  styleUrls: ['./share-popup.component.scss'],

})
export class SharePopupComponent {
  @Input() showPopup = false;
  @Input() type: 'CATALOGUE' | 'LEARNHUB' | 'JOBS' | 'DIRECTORY' | 'TALENTS' | 'NEWSFEEDS' = 'CATALOGUE';
  @Input() data: any;


  @Output() close = new EventEmitter<void>();

  constructor(private snackBar: MatSnackBar, private router: Router, private _dialog: MatDialog, private toast: ToastService) { }

  ngOnInit(): void {

  }

  closeChatPopup(): void {
    this.close.emit();

  }

  showSharePopup = false;
  frontendBaseUrl = `${environment.frontendPath}/prelogin`;
  backendBaseUrl = `${environment.serverPath}/api/v1/prelogin`;

  get backendShareUrl(): string {
    return `${this.backendBaseUrl}/${this.data?.id}`;
  }

  get frontendShareUrl(): string {
    return `${this.frontendBaseUrl}/${this.data?.id}`;
  }

  //  WhatsApp Share
  shareWhatsApp() {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(this.backendShareUrl)}`;
    window.open(whatsappUrl, '_blank');
    this.showSharePopup = false;
  }

  //  Instagram Share
  shareInstagram() {

  }

  //  Messenger Share
  shareMessenger() {
    const messengerUrl = `https://www.facebook.com/dialog/send?link=${encodeURIComponent(
      this.backendShareUrl
    )}&app_id=YOUR_FACEBOOK_APP_ID&redirect_uri=${encodeURIComponent(
      this.frontendShareUrl
    )}`;
    window.open(messengerUrl, '_blank');
    this.showSharePopup = false;
  }

  //  Facebook Share
  shareFacebook() {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      this.backendShareUrl
    )}`;
    window.open(facebookUrl, '_blank');
    this.showSharePopup = false;
  }

  //  Twitter / X Share
  shareTwitter() {
    const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      this.backendShareUrl
    )}&text=${encodeURIComponent('Check out this post!')}`;
    window.open(twitterUrl, '_blank');
    this.showSharePopup = false;
  }

  copyLink(): void {
    navigator.clipboard.writeText(this.backendShareUrl).then(() => {
      this.closeChatPopup();
      this.snackBar.open('Link copied', '', {
        duration: 2000,
        horizontalPosition: 'left',
        verticalPosition: 'bottom',
        panelClass: ['snackbar-success']
      });

    });
  }
}


